import { fallbackWidth, srcFor, srcSetFor, type SiteImageEntry } from '../../content/images';

interface SiteImageProps {
  image: SiteImageEntry;
  className?: string;
  /** Rendered width hints for the browser's srcset choice. */
  sizes?: string;
  /** Above-the-fold images pass "eager"; everything else stays lazy. */
  loading?: 'lazy' | 'eager';
}

/**
 * A manifest image (PRP-14) as a responsive WebP <img>: width/height from the
 * manifest (no layout shift), lazy by default, and alt="" + aria-hidden when the
 * image is decorative. A manifest `focus` sets object-position so crops keep faces.
 */
export function SiteImage({
  image,
  className = '',
  sizes = '(min-width: 1024px) 50vw, 100vw',
  loading = 'lazy',
}: SiteImageProps) {
  return (
    <img
      src={srcFor(image, fallbackWidth(image))}
      srcSet={srcSetFor(image)}
      sizes={sizes}
      width={image.width}
      height={image.height}
      alt={image.decorative ? '' : image.alt}
      aria-hidden={image.decorative ? true : undefined}
      loading={loading}
      decoding="async"
      className={className}
      style={image.focus ? { objectPosition: image.focus } : undefined}
    />
  );
}
